module.exports = __webpack_public_path__ + "static/media/clock.a84ae5b9.svg";